import React from "react";
import { connect } from "react-redux";

import styled from "styled-components";

const Link = styled.a`
  color: ${props => props.bg};
  span {
    background: ${props => props.bg};
    &:before,
    &:after {
      background: ${props => props.bg};
    }
  }
`;

const PrevStepButton = props => {
  const { onClick, text, baseColour } = props;
  return (
    <Link bg={baseColour} onClick={onClick} className="prev_step_btn">
      <span className="prev_step_btn--arrow" />
      {text}
    </Link>
  );
};

const mapStateToProps = state => {
  return {
    baseColour: state.app.domain.BaseColour
  };
};
export default connect(
  mapStateToProps,
  null
)(PrevStepButton);
